// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3VAq4","alert":"SettungsInbox_alert__3VCdR"};